import { HelpModal, HelpModalProps } from '@mi-front/ui';
import { FormattedMessage, useIntl } from 'react-intl';

/**
 * Help content for the "group by" option in the global missing audios report form.
 * All copy is driven by locale keys so every language (en, de, fr, pt, es) uses the same component.
 */
export function GroupByHelp(props: Pick<HelpModalProps, 'linkText' | 'trigger'>) {
  const { $t } = useIntl();

  return (
    <HelpModal {...props}>
      <div className={'mb-3'}>
        {$t({
          id: 'audit.globalMissingAudios.groupByHelp.intro',
          defaultMessage: 'Esta opción permite agrupar los schedules sin audios encontrados:',
        })}
      </div>
      <ul>
        <li>
          <FormattedMessage
            id="audit.globalMissingAudios.groupByHelp.noGroup"
            defaultMessage="<b>No agrupar</b>: devuelve todos los schedules encontrados. Puede haber varios schedules con el mismo custom ID."
            values={{
              b: (chunks) => <b>{chunks}</b>,
            }}
          />
        </li>
        <li>
          <FormattedMessage
            id="audit.globalMissingAudios.groupByHelp.groupByCustomId"
            defaultMessage="Agrupar por <b>custom ID</b>: los schedules se agrupan por custom ID, por lo que se devuelve un solo schedule por cada audio faltante en cualquiera de las radios seleccionadas."
            values={{
              b: (chunks) => <b>{chunks}</b>,
            }}
          />
        </li>
        <li>
          <FormattedMessage
            id="audit.globalMissingAudios.groupByHelp.groupByCustomIdAndRadio"
            defaultMessage="Agrupar por <b>custom ID y radio</b>: se devuelve un solo schedule por cada radio y cada custom ID."
            values={{
              b: (chunks) => <b>{chunks}</b>,
            }}
          />
        </li>
      </ul>
    </HelpModal>
  );
}
